import objectReduce from 'fast-loops/lib/objectReduce';
export default function createNode(nodes, score, _ref) {
  var type = _ref.type,
      media = _ref.media,
      support = _ref.support;
  var targetDocument = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : document;
  var head = targetDocument.head || {};
  var node = targetDocument.createElement('style');
  node.setAttribute('data-fela-type', type);
  node.type = 'text/css';

  if (support) {
    node.setAttribute('data-fela-support', 'true');
  }

  if (media) {
    node.media = media;
  } // we calculate the most next bigger style node
  // to correctly inject the node just before it


  var moreSpecificReference = objectReduce(nodes, function (closest, currentNode, reference) {
    return currentNode.score > score && (!closest || nodes[closest].score > currentNode.score) ? reference : closest;
  }, undefined);

  if (moreSpecificReference) {
    head.insertBefore(node, nodes[moreSpecificReference].node);
  } else {
    head.appendChild(node);
  }

  return node;
}